

var React = require('react');

class Audio extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      wasPlayed: false,
      isPlaying: false,
      canPlay: false,
      playQueued: false,
    }
  }

  componentDidMount(){
    this.audio.load();
  }

  onCanPlayThrough = () => {
    this.setState({
      canPlay: true,
    });
  }

  onPlay = () => {
    if (!this.state.canPlay){
        this.audio.load();
        this.setState({
          playQueued: true,
        })
      }

      if(this.state.canPlay && !this.props.isAudioPlaying){
        this.setState({
          isPlaying: true,
        });
        this.audio.play();
        this.props.toggleAudio();
      }
  }

  onEnded = () => {

    this.endAudio();

    if (this.props.toggleAudio){
      this.props.toggleAudio();
    }

    if(this.props.onEndedCallback){
      this.props.onEndedCallback();
    }

  }

  endAudio = () => {
    this.setState({
      wasPlayed: true,
      isPlaying: false,
    })
  }

  getAudioUrl = () => {

    const {audioUrl} = this.props.item;

    const {audioMode} = this.props.mode;

    if (audioUrl.hasOwnProperty(audioMode)){
      return(audioUrl[audioMode])
    }
  }

  componentWillUnmount(){
    if (this.props.setAudioFalse && this.props.isAudioPlaying) {
      console.log("Ending audio!");
      this.endAudio();
      this.props.setAudioFalse();
    }
  }

  render() {


    return(
      <div>
        <audio
          src={this.getAudioUrl()}
          type="audio/ogg"
          onCanPlayThrough={this.onCanPlayThrough}
          onError={this.props.onErrors}
          ref={(Audio) => {this.audio = Audio;}}
          onPlay={this.onPlay}
          onEnded={this.onEnded}
        />
    </div>
    )
  }
}

export default Audio;



// WEBPACK FOOTER //
// ./src/comp/Audio.js